/**
 * Takes a path and converts it to the array representation of directories
 * For example /abc/def becomes ["root","abc","def"]
 *
 * @param path
 */
export const pathToArray = (path) => {
  return ['root'].concat(path.split('/').filter((x) => x !== ''));
};
